import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { useStore } from '../../data/store';

const defaultSponsors = [
  'Katholische Kirchengemeinde Peter und Paul',
  'Stadt Bad Hönningen',
  'prOju',
  'Sponsor Platz 1',
  'Sponsor Platz 2',
  'Sponsor Platz 3',
  'Sponsor Platz 4',
];

export default function Sponsors() {
  const settings = useStore((s) => s.settings);
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="bg-bg-secondary section-padding">
      <div
        ref={ref}
        className={`max-w-5xl mx-auto transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <h2 className="font-heading text-2xl md:text-3xl text-text-muted text-center mb-10 md:mb-14">UNSERE PARTNER</h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {defaultSponsors.map((sponsor) => (
            <div key={sponsor} className="bg-bg-card border border-divider p-5 md:p-8 flex items-center justify-center min-h-[100px] md:min-h-[120px]">
              <span className="font-body text-text-muted text-xs sm:text-sm text-center">{sponsor}</span>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-14 space-y-2">
          <p className="font-body text-text-muted text-sm">{settings?.contactEmail} | Kirchstraße 18, 53557 Bad Hönningen</p>
        </div>
      </div>

    </section>
  );
}
